import { InjectionToken } from '@angular/core';
import { IAppointmentService } from './appointment-service.interface';

export const APPOINTMENT_SERVICE = new InjectionToken<IAppointmentService>(
  'APPOINTMENT_SERVICE'
);
